import { Component, h } from 'preact'
import { FilterSelectorComponent } from './interfaces'
import SearchableFilterSelector from './SearchableFilterSelector'
import FilterOption from './FilterOption'

type State = {
  data: any
}

class SimpleFilterSelector extends Component<FilterSelectorComponent, State> {
  constructor (props: FilterSelectorComponent) {
    super(props)
    this.state = {
      data: this.props.selectedFilterItems
    }
  }

  onFilterOptionSelection = (payload: string | string[]) => {
    this.setState({ data: payload })
  }

  render ({ name, items, selectedFilterItems, isSearchable, children }: FilterSelectorComponent, { data }: State) {
    return <div>
      {isSearchable ? <SearchableFilterSelector items={items} placeholder={`Search for ${name}`}>
        {({ items }: { items: any[] }) => {
          return items.map(item => {
            if (item.name === 'separator') {
              return <hr class='separator' />
            }
            if (item.name === 'title') {
              return <div className='overview__filters-box-filter overview__filters-box-filter-title'> {item.value} </div>
            }
            return <FilterOption
              item={item} data={data}
              onFilterOptionSelection={this.onFilterOptionSelection}
            />
          })
        }}
      </SearchableFilterSelector>
        : items.map(item => {
          if (item.name === 'separator') {
            return <hr class='separator' />
          }
          if (item.name === 'title') {
            return <div className='overview__filters-box-filter overview__filters-box-filter-title'> {item.value} </div>
          }
          return <div class='overview__filters-box-content'>
            <FilterOption
              item={item} data={data}
              onFilterOptionSelection={this.onFilterOptionSelection}
            />
          </div>
        })
      }
      {children[0]({
        data,
        isApplyButtonDisabled: data.length === 0
      })}
    </div>
  }
}

export default SimpleFilterSelector
